import domReady from './inc/dom-ready.js';
import elmntIO from './inc/elmnt-io.js';
import { boilerplateNavMain } from './inc/nav-main.js';
import { mediaSlider } from './inc/media-slider.js';
import { videoGallery } from './inc/video-gallery.js';


domReady( function () {
    //do something after DOM loads.

    boilerplateNavMain();

    const $elmentIOs = document.querySelectorAll('[data-io]');
    if ( $elmentIOs ) {
        $elmentIOs.forEach($el => elmntIO($el));
    }

    mediaSlider();
    videoGallery();
    
} );